import { render, staticRenderFns } from "./ConsultarPaqueteAsignado.vue?vue&type=template&id=2139acda&scoped=true"
import script from "./ConsultarPaqueteAsignado.vue?vue&type=script&lang=js"
export * from "./ConsultarPaqueteAsignado.vue?vue&type=script&lang=js"
import style0 from "./ConsultarPaqueteAsignado.vue?vue&type=style&index=0&id=2139acda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2139acda",
  null
  
)

export default component.exports